/* ==========================================================================
   ELORE — Contact Page Section
   assets/elore-contact.js
   Extracted verbatim (logic unchanged) from the original inline
   IntersectionObserver script in code.html. Only the load-trigger was
   adapted so it still runs correctly when this file is loaded with
   `defer` from a Shopify section (where DOMContentLoaded may already
   have fired by the time the script executes), and so it re-runs if the
   section is re-injected by the Shopify theme editor.
   ========================================================================== */

(function () {
    function initEloreFadeUp() {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-up-enter-active');
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px"
        });

        document.querySelectorAll('.fade-up-enter').forEach(function (el) {
            // Remove class initially if not in viewport
            if (el.getBoundingClientRect().top > window.innerHeight) {
                el.classList.remove('fade-up-enter-active');
            }
            observer.observe(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEloreFadeUp);
    } else {
        initEloreFadeUp();
    }

    // Re-init when the theme editor re-renders this section
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.querySelector('.fade-up-enter')) {
            initEloreFadeUp();
        }
    });
})();
